import { filter, indexOf, without } from 'lodash';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { DiscountRules } from '@shared/app/scripts/services/discount-rules';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { Mask } from '@core/app/scripts/services/mask';

/*
 * Component responsible for /discount-settings route.
 */
angular
  .module('posApp')
  .directive(
    'discountSettings',
    (
      discountRules: DiscountRules,
      displayMessage: DisplayMessage,
      mask: Mask,
      navigateTo: NavigateTo,
      pos,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./discount-settings.html').default,

      link: function ($scope, element, attrs) {
        pos.selectedDiscountRule = -1;

        $scope.showActive = true;

        let automatedDiscounts = [];

        $scope.showAutomatedDiscounts = [];

        $scope.exitForm = () => {
          navigateTo('pos.route#more');
        };

        $scope.loadDiscountRules = function () {
          displayMessage.showLoading();

          discountRules
            .filter({ active: $scope.showActive }, undefined, 500, {
              modified_history: 0,
            })
            .then((response: any) => {
              mask.hide();
              if (!response || response.length === 0) {
                return;
              } //no discount rules

              console.log(
                '[Automated Discounts] Loading ' +
                  response.length +
                  ' Rules...',
              );

              automatedDiscounts = response;
              $scope.showAutomatedDiscounts = response;
            });
        };

        // ngOnInit
        $scope.loadDiscountRules();

        $scope.dragToSort = (targetItem, draggedItem) => {
          // Process the location of the dragged item
          const targetIndex = indexOf(
            $scope.showAutomatedDiscounts,
            targetItem,
          );
          const copyDragged = angular.copy(draggedItem);

          $scope.showAutomatedDiscounts = without(
            $scope.showAutomatedDiscounts,
            draggedItem,
          );

          $scope.showAutomatedDiscounts.splice(targetIndex, 0, copyDragged);

          angular.forEach(automatedDiscounts, (discrule, indx) => {
            discrule.priority = indx;
          });

          discountRules.save(automatedDiscounts).then(() => {
            mask.hide();
          });
        };

        $scope.addDiscountRule = () => {
          navigateTo('pos.route#discount-rule/add-new');
        };

        $scope.editDiscountRule = (discountRule) => {
          //broadcaster.send('editDiscountRule', discountRule);
          navigateTo(`pos.route#discount-rule/${discountRule._id}`);
        };

        $scope.toggleShowActive = () => {
          $scope.showActive = !$scope.showActive;

          $scope.loadDiscountRules();
        };
      },
    }),
  );
